import Vue from 'vue'
// 引入全部样式
import 'vant/lib/index.less';
import { 
    Button,
    Cell,
    CellGroup,
    Icon,
    Row,
    Col,
    Popup,
    DatetimePicker,
    Field,
    Picker,
    RadioGroup, 
    Radio,
    Uploader,
    NumberKeyboard,
    Checkbox, 
    CheckboxGroup,
    Dialog,
    Toast,
    Overlay,
    SwipeCell,
    PullRefresh,
    ActionSheet,
    Notify,
    Divider,
    DropdownMenu, 
    DropdownItem,
    NoticeBar,
    List,
    Panel,
    Skeleton,
    Collapse, 
    CollapseItem,
    ImagePreview,
    Step,
    Steps,
    Tag,
    Grid,
    GridItem,
    NavBar,
    Tab,
    Tabs,
    Tabbar,
    TabbarItem,
    Card,
    ContactCard,
    ContactList,
    ContactEdit,
    Swipe,
    SwipeItem,
    Progress,
    Switch,
    Form,
    Image,
    Empty,
    Slider,
    Popover,
    Cascader,
    Sticky,
    Sidebar, 
    SidebarItem,
    Badge,
} from 'vant';

Vue
.use(Button)
.use(Cell)
.use(CellGroup)
.use(Icon)
.use(Row)
.use(Col)
.use(Popup)
.use(DatetimePicker)
.use(Field)
.use(Picker)
.use(RadioGroup)
.use(Radio)
.use(Uploader)
.use(NumberKeyboard)
.use(Checkbox)
.use(CheckboxGroup)
.use(Dialog)
.use(Toast)
.use(Overlay)
.use(SwipeCell)
.use(PullRefresh)
.use(ActionSheet)
.use(Notify)
.use(Divider)
.use(DropdownMenu)
.use(DropdownItem)
.use(NoticeBar)
.use(List)
.use(Panel)
.use(Skeleton)
.use(Collapse)
.use(CollapseItem)
.use(ImagePreview)
.use(Step)
.use(Steps)
.use(Tag)
.use(Grid)
.use(GridItem)
.use(NavBar)
.use(Tab)
.use(Tabs)
.use(Tabbar)
.use(TabbarItem)
.use(Card)
.use(ContactCard)
.use(ContactList)
.use(ContactEdit)
.use(Swipe)
.use(SwipeItem)
.use(Progress)
.use(Switch)
.use(Form)
.use(Image)
.use(Empty)
.use(Slider)
.use(Popover)
.use(Cascader)
.use(Sticky)
.use(Sidebar)
.use(SidebarItem)
.use(Badge);

Vue.prototype.$Toast = Toast;